// @generated by protoc-gen-connect-es v1.6.1 with parameter "target=ts"
// @generated from file issue/issue.proto (package vsmr.issue.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { AddIssueCommentRequest, CreateIssueRequest, DeleteIssueCommentRequest, GetIssueAttachmentPolicyRequest, GetIssueAttachmentRequest, GetIssueAttachmentResponse, GetIssueDetailResponse, GetIssueRequest, IssueAttachmentPolicy, IssueAttachmentResponse, IssueCommentResponse, IssueResponse, ListIssuesRequest, ListIssuesResponse, UpdateIssueCommentRequest, UpdateIssueMetaRequest, UpdateIssueRequest, UpdateIssueStateRequest, UploadIssueAttachmentRequest } from "./issue_pb.js";
import { MethodKind } from "@bufbuild/protobuf";

/**
 * @generated from service vsmr.issue.v1.IssueService
 */
export const IssueService = {
  typeName: "vsmr.issue.v1.IssueService",
  methods: {
    /**
     * 이슈 등록 — 로그인 사용자 누구나.
     *
     * @generated from rpc vsmr.issue.v1.IssueService.CreateIssue
     */
    createIssue: {
      name: "CreateIssue",
      I: CreateIssueRequest,
      O: IssueResponse,
      kind: MethodKind.Unary,
    },
    /**
     * 목록 — 기본은 자기 이슈. all_users 는 admin 전용(전체 보기).
     *
     * @generated from rpc vsmr.issue.v1.IssueService.ListIssues
     */
    listIssues: {
      name: "ListIssues",
      I: ListIssuesRequest,
      O: ListIssuesResponse,
      kind: MethodKind.Unary,
    },
    /**
     * 상세(코멘트 포함) — 작성자 또는 admin.
     *
     * @generated from rpc vsmr.issue.v1.IssueService.GetIssue
     */
    getIssue: {
      name: "GetIssue",
      I: GetIssueRequest,
      O: GetIssueDetailResponse,
      kind: MethodKind.Unary,
    },
    /**
     * 코멘트 — 작성자 또는 admin (왕복 대화).
     *
     * @generated from rpc vsmr.issue.v1.IssueService.AddIssueComment
     */
    addIssueComment: {
      name: "AddIssueComment",
      I: AddIssueCommentRequest,
      O: IssueCommentResponse,
      kind: MethodKind.Unary,
    },
    /**
     * close/reopen — 작성자 또는 admin (GitHub 관례).
     *
     * @generated from rpc vsmr.issue.v1.IssueService.UpdateIssueState
     */
    updateIssueState: {
      name: "UpdateIssueState",
      I: UpdateIssueStateRequest,
      O: IssueResponse,
      kind: MethodKind.Unary,
    },
    /**
     * 라벨·담당자 — admin 전용.
     *
     * @generated from rpc vsmr.issue.v1.IssueService.UpdateIssueMeta
     */
    updateIssueMeta: {
      name: "UpdateIssueMeta",
      I: UpdateIssueMetaRequest,
      O: IssueResponse,
      kind: MethodKind.Unary,
    },
    /**
     * 제목·본문 편집 — 작성자만(admin 도 남의 글은 못 고친다: 발언 변조 방지).
     * 닫힌 이슈도 허용. 편집은 edited_at 을 남기고 updated_at 을 올린다. 알림 없음.
     *
     * @generated from rpc vsmr.issue.v1.IssueService.UpdateIssue
     */
    updateIssue: {
      name: "UpdateIssue",
      I: UpdateIssueRequest,
      O: IssueResponse,
      kind: MethodKind.Unary,
    },
    /**
     * 코멘트 본문 편집 — 코멘트 작성자만. 본문의 첨부 참조는 등록과 같은 검증을 탄다.
     *
     * @generated from rpc vsmr.issue.v1.IssueService.UpdateIssueComment
     */
    updateIssueComment: {
      name: "UpdateIssueComment",
      I: UpdateIssueCommentRequest,
      O: IssueCommentResponse,
      kind: MethodKind.Unary,
    },
    /**
     * 코멘트 삭제 — 코멘트 작성자 또는 admin. 소프트 삭제: 본문을 비우고 자리를
     * 남긴다(deleted=true). 이미 지운 코멘트는 NOT_FOUND. 첨부는 이슈 귀속이라 그대로.
     *
     * @generated from rpc vsmr.issue.v1.IssueService.DeleteIssueComment
     */
    deleteIssueComment: {
      name: "DeleteIssueComment",
      I: DeleteIssueCommentRequest,
      O: IssueCommentResponse,
      kind: MethodKind.Unary,
    },
    /**
     * 스크린샷 업로드 — 로그인 사용자 누구나. 작성 중(이슈 생성 전)에도
     * 허용되며, 본문이 `vsmr-attachment://{id}` 로 참조한 첨부는
     * CreateIssue/AddIssueComment 시점에 해당 이슈로 귀속된다.
     *
     * @generated from rpc vsmr.issue.v1.IssueService.UploadIssueAttachment
     */
    uploadIssueAttachment: {
      name: "UploadIssueAttachment",
      I: UploadIssueAttachmentRequest,
      O: IssueAttachmentResponse,
      kind: MethodKind.Unary,
    },
    /**
     * 첨부 내려받기 — 귀속된 첨부는 이슈 가시성(작성자 또는 admin)을,
     * 아직 미귀속인 첨부는 업로더 본인만 접근을 허용한다.
     *
     * @generated from rpc vsmr.issue.v1.IssueService.GetIssueAttachment
     */
    getIssueAttachment: {
      name: "GetIssueAttachment",
      I: GetIssueAttachmentRequest,
      O: GetIssueAttachmentResponse,
      kind: MethodKind.Unary,
    },
    /**
     * 첨부 정책 — 서버가 받는 첨부 형식. 웹은 파일을 고를 때 이것으로 미리 판정한다(형식 목록은 서버 한 곳 —
     * UploadIssueAttachment 가 같은 목록으로 거절한다). 크기 상한은 IssueLimit 이 선언한다.
     *
     * @generated from rpc vsmr.issue.v1.IssueService.GetIssueAttachmentPolicy
     */
    getIssueAttachmentPolicy: {
      name: "GetIssueAttachmentPolicy",
      I: GetIssueAttachmentPolicyRequest,
      O: IssueAttachmentPolicy,
      kind: MethodKind.Unary,
    },
  }
} as const;

